import React from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import CookieBanner from './CookieBanner';

export default function PublicLayout({ children }) {
  return (
    <div className="bg-white text-slate-900 min-h-screen flex flex-col dark:bg-slate-950 dark:text-slate-100 transition-colors">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
      <CookieBanner />
    </div>
  );
}

export function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)' }}>
      <div className="absolute -top-32 -right-20 w-[500px] h-[500px] bg-blue-500/20 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-32 -left-20 w-[500px] h-[500px] bg-indigo-500/20 rounded-full blur-3xl"></div>
      <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-24 text-white">
        {eyebrow && <div className="text-blue-200 text-sm font-semibold uppercase tracking-widest">{eyebrow}</div>}
        <h1 className="text-4xl md:text-5xl font-bold mt-2 leading-tight">{title}</h1>
        {subtitle && <p className="mt-5 text-lg text-blue-100 max-w-2xl">{subtitle}</p>}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
